import { render, staticRenderFns } from "./InputEntity.vue?vue&type=template&id=a56c6b8a&scoped=true&"
import script from "./InputEntity.vue?vue&type=script&lang=ts&"
export * from "./InputEntity.vue?vue&type=script&lang=ts&"
import style0 from "./InputEntity.vue?vue&type=style&index=0&id=a56c6b8a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56c6b8a",
  null
  
)

export default component.exports